<template>
  <div>
    <h3 ref="ia">
      Mean
    </h3>
    <p>
      In statistics, mean and standard deviation are used to described the values in a set.
      The mean value of a data set represents the average of all the values in the set.
      It is calculated as the sum of all the values in the set divided by the size of the set.
      Consider a data set containing n values: \(x = {x_1, x_2, x_3, ..., x_n} \). Then the mean of this data set is given as:
      $$\mu = \frac{x_1+x_2+ ...+x_n}{n}= \frac{\sum x_i}{n}$$
    </p>
    <h3 ref="ia">
      Median
    </h3>
    <p>
      The median of a set is the value at the middle of a sorted data set. Half of the values are greater than the median and other half of the values
      are smaller than median.
      The median is found by ordering the set from lowest to highest and locating the value in the exact middle.
    </p>
    <h3 ref="meth">
      Standard Deviation
    </h3>
    <p>
      Standard deviation is a measure of the spread in the data from the mean value. Standard deviation is typically represented by the symbol \(\sigma\).
      A low standard deviation means that the values in the set lie within a narrow window around the mean (i.e., the values are close to the mean). Conversely,
      a high standard deviation means that the values spread over a wide window around the mean.
      Mathematically, the standard deviation is given as:
    </p>
    $$\sigma = \sqrt{\frac{(x_1-\mu)^2+(x_2-\mu)^2+ ...+(x_n-\mu)^2}{n}}= \sqrt{\frac{\sum (x_i-\mu)^2}{n}}$$
    <h3 ref="pg">
      MagicGraph | Mean & Standard Deviation
    </h3>
    <p> In this MagicGraph, You will learn about the mean and the standard deviation of a dataset.</p>
    <ul style="list-style-type: square;">
      <li><h5>Getting Started</h5> You are to choose from a pack of 10 dogs. You're supposed to choose 5 dogs. To select, click on the dogs that you would like to choose.  </li> <br>
      <li>
        <h5>To Explore</h5>
        Select different combinations of dogs to see how the mean and standard deviation change.
      </li> <br>
    </ul>
    <p> You can repeat the above steps any number of times to learn different scenarios. </p>
    <br>
    <v-responsive>
      <v-layout justify-center>
        <div id="jxgbox1" class="edliy-box-about" />
      </v-layout>
    </v-responsive>
  </div>
</template>
<script>
import Boxes from './Boxes.js'
export default {
  name: 'Resistors',
  created: function () {
    this.$store.commit('navigation/resetState');
    let title = 'Mean and Standard Deviation';
    this.$store.commit('navigation/changeTitle', title);
    this.$store.commit('navigation/changeMenu', title);
    let newTopics = [
      {title: 'Mean', img:'/assets/number-1.svg', action: () => this.goto('ia')},
      {title: 'Standard Deviation', img:'/assets/number-2.svg', action: () => this.goto('meth')},
      {title: 'MagicGraph',img:'/assets/touch.svg', action: () => this.goto('pg')},
    ];
    this.$store.commit('navigation/replaceTopics', newTopics);
    let newshowhome = false;
    this.$store.commit('navigation/toggleshowhome', newshowhome);
    let newMath =true;
    this.$store.commit('navigation/replaceMath', newMath);
    let newLeftArrow =true;
    this.$store.commit('navigation/replaceLeftArrow', newLeftArrow);
    let newModule=true;
    this.$store.commit('navigation/replaceModule', newModule);
  },
  mounted () {
    MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    Boxes.box1();
  },
  metaInfo() {
  return{ title: 'Mean, Median and Standard Deviation',
          titleTemplate: '%s - Learn interactively',
          meta: [ {name: 'viewport', content: 'width=device-width, initial-scale=1'},
                  {name: 'description', content: 'Learn interactively about mean, median and standard deviation.'}
                ]
        }
   },
}
</script>
<style lang="scss">
@import 'src/styles/edliy-box.scss';
@import 'src/styles/subtopic-menu.scss';
@import 'src/styles/edliy-box-about.scss';
@import 'src/styles/screen-sizes.scss';
</style>
